import { AxiosError } from "axios"
import { http } from "config/http"

type GetGroupsListServiceResponse = {
	id: number
	created_by: number
	updated_by: null | number
	is_active: boolean
	created_at: string
	name: string
	description: string
	updated_at: string
}[]

export const getGroupsListService = async () => {
	try {
		const res = await http.get<GetGroupsListServiceResponse>(`get_all_groups?client_env=${localStorage.getItem("clientName")}`)
		return { response: res?.data }
	} catch (error) {
		if (error instanceof AxiosError) {
			return { error: error.message }
		}
		return { response: undefined, error: error }
	}
}

type GetGroupsByIdServiceResponse = {
	id: 1
	name: string
	description: string
	assigned_roles: {
		role_id: number
		name: string
	}[]
	unassigned_roles: {
		role_id: number
		name: string
	}[]
	assigned_users: {
		id: number
		first_name: string
		last_name: string
		email: string
	}[]
	unassigned_users: {
		id: number
		first_name: string
		last_name: string
		email: string
	}[]
	error?: string
}

export const getGroupsByIdService = async (id: string | undefined) => {
	try {
		const res: any = await http.get<GetGroupsByIdServiceResponse>(
			`get_group_by_id?group_id=${id}&client_env=${localStorage.getItem("clientName")}`
		)
		return { response: res?.data }
	} catch (error: any) {
		return { error: error.message }
	}
}

type AddGroupServiceResponse = {
	error?: string
	message: string
}

export const addGroupService = async (body: {
	group_name: string
	description: string
}) => {
	const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
	try {
		const res = await http.post<AddGroupServiceResponse>("add_group", destinationObject)
		return { response: res?.data, error: undefined }
	} catch (error) {
		if (error instanceof AxiosError) {
			return { error: error.message }
		}
		return { response: undefined, error: error }
	}
}

type UpdateGroupServiceResponse = {
	error?: string
	message: string
}

export const updateGroupService = async (body: {
	group_id: number
	group_name: string
	description: string
	error?: string
	updated_by: string
}) => {
	const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
	try {
		const res = await http.put<UpdateGroupServiceResponse>("update_group", destinationObject)
		return { response: res?.data, error: undefined }
	} catch (error) {
		if (error instanceof AxiosError) {
			return { error: error.message }
		}
		return { response: undefined, error: error }
	}
}

type ActiveInactiveGroupServiceType = {
	error?: string
	message: string
}
export const activeInactiveGroupService = async (body: {
	for_active: boolean
	group_id: string[]
}) => {
	const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
	try {
		const res = await http.post<ActiveInactiveGroupServiceType>(
			"active_deactive_group",
			destinationObject
		)
		return { response: res.data, error: undefined }
	} catch (error) {
		if (error instanceof AxiosError) {
			return { error: error.message }
		}
		return { response: undefined, error: error }
	}
}

// export const deleteUsersData = async (body: any) => {
// 	try {
// 		const res: any = await http.post(`user_active_deactive`, body)
// 		return { response: res?.data }
// 	} catch (error: any) {
// 		return { error: error.message }
// 	}
// }

type UnassignRoleFromGroupServiceProps = {
	message: string
	error?: string
}

export const unassignRoleFromGroupService = async (body: {
	group_id: number
	role_id: number | number[]
}) => {
	try {
		const res = await http.put<UnassignRoleFromGroupServiceProps>(
			"role_unassign_to_group",
			{
				group_id: body.group_id,
				role_id: Array.isArray(body.role_id) ? body.role_id : [body.role_id],
				updated_by: window && window.localStorage.getItem("username"),
				client_env: localStorage.getItem("clientName")
			}
		)
		return { response: res.data, error: undefined }
	} catch (error) {
		if (error instanceof AxiosError) {
			return { error: error.message }
		}
		return { response: undefined, error: error }
	}
}

type AssignRoleToGroupServiceProps = {
	message: string
	error?: string
}

export const assignRoleToGroupService = async (body: {
	group_id: number
	role_id: number | number[]
}) => {
	try {
		const res = await http.put<AssignRoleToGroupServiceProps>(
			"role_assign_to_group",
			{
				group_id: body.group_id,
				role_id: Array.isArray(body.role_id) ? body.role_id : [body.role_id],
				updated_by: window && window.localStorage.getItem("username"),
				client_env: localStorage.getItem("clientName")
			}
		)
		return { response: res.data, error: undefined }
	} catch (error) {
		if (error instanceof AxiosError) {
			return { error: error.message }
		}
		return { response: undefined, error: error }
	}
}

type UnassignUserFromGroupServiceProps = {
	message: string
	error?: string
}

export const unassignUserFromGroupService = async (body: {
	group_id: number
	user_id: number | number[]
}) => {
	try {
		const res = await http.put<UnassignUserFromGroupServiceProps>(
			"user_unassign_to_group",
			{
				group_id: body.group_id,
				user_id: Array.isArray(body.user_id) ? body.user_id : [body.user_id],
				updated_by: window && window.localStorage.getItem("username"),
				client_env: localStorage.getItem("clientName"),
			}
		)
		return { response: res.data, error: undefined }
	} catch (error) {
		if (error instanceof AxiosError) {
			return { error: error.message }
		}
		return { response: undefined, error: error }
	}
}

type AssignUserToGroupServiceProps = {
	message: string
	error?: string
}

export const assignUserToGroupService = async (body: {
	group_id: number
	user_id: number | number[]
}) => {
	try {
		const res = await http.put<AssignUserToGroupServiceProps>(
			"user_assign_to_group",
			{
				group_id: body.group_id,
				user_id: Array.isArray(body.user_id) ? body.user_id : [body.user_id],
				updated_by: window && window.localStorage.getItem("username"),
				client_env: localStorage.getItem("clientName"),
			}
		)
		return { response: res.data, error: undefined }
	} catch (error) {
		if (error instanceof AxiosError) {
			return { error: error.message }
		}
		return { response: undefined, error: error }
	}
}


export const updateGroupFeatureFlagData = async (body: any) => {
	const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
	try {
		const res: any = await http.put("group_feature_flag", destinationObject)
		return { result: res?.data }
	} catch (error: any) {
		return { error: error.message }
	}
}

export const getGroupFeatureFlagData = async (name: string) => {
	try {
		const res: any = await http.get(`get_group_flag_info?group_name=${name}&client_env=${localStorage.getItem("clientName")}`)
		return { result: res?.data }
	} catch (error: any) {
		return { error: error.message }
	}
}